import Api from '@/services/Api'
import router from '@/router'
import store from '@/store'

export default {
  isoList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending) {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'itiso/default.asp?controller=it_req&action=List' + param,
      credentials
    )
  },
  isoByID(credentials) {
    // console.log('credentials', credentials)
    var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'itiso/default.asp?controller=it_req&action=ListByParam' + param,
      credentials
    )
  },
  isoRate(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'itiso/default.asp?controller=it_req&action=Rating',
      credentials
    )
  },
  SelectByItemCode(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'itiso/default.asp?controller=it_req&action=SelectByItemCode',
      credentials
    )
  },
  ListByParam(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'itiso/default.asp?controller=it_req&action=ListByParam',
      credentials
    )
  },
  Insert(credentials) {
    // console.log('credentials', credentials)
    // var param // = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'itiso/default.asp?controller=it_req&action=insert',
      credentials
    )
  },
  Update(credentials) {
    // console.log('credentials', credentials)
    // var param // = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'itiso/default.asp?controller=it_req&action=Update',
      credentials
    )
  },

  // EmpRole Service ------------------------------------
  emproleList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'itiso/default.asp?controller=emprole&action=list' + param,
      credentials
    )
  },
  emproleItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'itiso/default.asp?controller=emprole&action=listbyparam',
      credentials
    )
  },
  emproleListByParam(credentials) {
    return Api.httpServer().post(
      'itiso/default.asp?controller=emprole&action=listbyparam',
      credentials
    )
  },
  emproleInsert(credentials) {
    return Api.httpServer().post(
      'itiso/default.asp?controller=emprole&action=insert',
      credentials
    )
  },
  emproleUpdate(credentials) {
    return Api.httpServer().post(
      'itiso/default.asp?controller=emprole&action=update',
      credentials
    )
  },
  emproleDelete(credentials) {
    return Api.httpServer().post(
      'itiso/default.asp?controller=emprole&action=delete',
      credentials
    )
  },
  // s2type Service ------------------------------------
  s2typeList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'itiso/default.asp?controller=s2type&action=list' + param,
      credentials
    )
  },
  s2typeItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'itiso/default.asp?controller=s2type&action=listbyparam',
      credentials
    )
  },
  s2typeListByParam(credentials) {
    return Api.httpServer().post(
      'itiso/default.asp?controller=s2type&action=listbyparam',
      credentials
    )
  },
  s2typeInsert(credentials) {
    return Api.httpServer().post(
      'itiso/default.asp?controller=s2type&action=insert',
      credentials
    )
  },
  s2typeUpdate(credentials) {
    return Api.httpServer().post(
      'itiso/default.asp?controller=s2type&action=update',
      credentials
    )
  },
  s2typeDelete(credentials) {
    return Api.httpServer().post(
      'itiso/default.asp?controller=s2type&action=delete',
      credentials
    )
  },
  // emp Service ------------------------------------
  empList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'ITISO/default.asp?controller=emp&action=list' + param,
      credentials
    )
  },
  empItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'ITISO/default.asp?controller=emp&action=listbyparam',
      credentials
    )
  },
  empListByParam(credentials) {
    return Api.httpServer().post(
      'ITISO/default.asp?controller=emp&action=listbyparam',
      credentials
    )
  },
  empInsert(credentials) {
    return Api.httpServer().post(
      'ITISO/default.asp?controller=emp&action=insert',
      credentials
    )
  },
  empUpdate(credentials) {
    return Api.httpServer().post(
      'ITISO/default.asp?controller=emp&action=update',
      credentials
    )
  },
  empDelete(credentials) {
    return Api.httpServer().post(
      'ITISO/default.asp?controller=emp&action=delete',
      credentials
    )
  },
  //<services>

  errorHandel(res) {
    if (res.status === 401) {
      store.state.users.main = {}
      router.push('/signin')
    }
  }
}
